/**
 * ResponsiveTable - DEPRECATED
 * 
 * This file now re-exports DataTable for backward compatibility.
 * All existing imports will continue to work.
 * 
 * Please update imports to use DataTable directly:
 * OLD: import ResponsiveTable from '../Components/UI/ResponsiveTable';
 * NEW: import DataTable from '../Components/UI/DataTable';
 * 
 * The component has been consolidated and modernized:
 * - Uses MUI theme system (no more styled-components)
 * - Professional color palette (from the MUI theme)
 * - Better performance with sx prop
 * - Consistent styling across the app
 */

import DataTable, { StatusBadge, ActionMenu } from './DataTable';

// Re-export with old name for backward compatibility
export const ResponsiveTable = DataTable;
export { StatusBadge, ActionMenu };
export default DataTable;
